import React, { Component } from 'react'

import { withTheme } from '../../shared/theming-sc'
import CurrentIndexFaC from '../facc-current-index'

class PaginationContainer extends Component {
  constructor(props) {
    super(props)

    this.state = {
      totalPages: Math.ceil(
        this.props.criterion.total / this.props.criterion._perpage
      )
    }
  }

  componentWillReceiveProps(nextProps) {
    const totalPages = Math.ceil(
      nextProps.criterion.total / nextProps.criterion._perpage
    )

    this.setState({
      totalPages
    })
  }

  callBack(callBackValue) {
    if (typeof callBackValue === 'function') {
      return callBackValue
    } else if (typeof callBackValue === 'string') {
      return this.aemCallBack(callBackValue)
    } else {
      return () => {}
    }
  }

  aemCallBack = functionName => {
    return (idx) => {
      try {
        window.TR_pageFunctions[functionName](idx)
      } catch (error) {
        console.log('Alerts Tray: error while executing a callback - ' + error)
      }
    }
  }

  render() {
    const { children } = this.props

    return (
      <CurrentIndexFaC basicPaginationEnabled={this.props.criterion.basicPaginationEnabled} currentIndex={this.props.currentIndex} totalItems={this.state.totalPages} onCurrentIndexChanged={this.callBack(this.props.config.onCurrentIndexChanged)}>
        {({ currentIndex, currentIndexProps }) =>
          children({
            ...currentIndexProps,
            currentIndex,
            ...this.props,
            ...this.state
          })
        }
      </CurrentIndexFaC>
    )
  }
}

export default withTheme(PaginationContainer)
